<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-09-10 18:05:42
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTab">
        <div class="title">任务详情</div>
        <div class="infoItem">
          <div class="infoTitle">编号：</div>
          <div>{{ detail.jobNo }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">发布人：</div>
          <div>{{ taskDetail.creatorName }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">创建时间：</div>
          <div>{{ detail.gmtCreate }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">发布范围：</div>
          <div>{{ taskDetail.rangeName }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">人数：</div>
          <div>{{ taskDetail.readiesNum }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">任务地址：</div>
          <div>{{ taskDetail.address }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">订单状态：</div>
          <div v-if="taskDetail.status == 0">已取消</div>
          <div v-if="taskDetail.status == 1">待发布</div>
          <div v-if="taskDetail.status == 2">待发布</div>
          <div v-if="taskDetail.status == 3">待实做</div>
          <div v-if="taskDetail.status == 4">实做中</div>
          <div v-if="taskDetail.status == 5">已完成</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">发布时间：</div>
          <div>{{ taskDetail.actionAt }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">需求人数：</div>
          <div>{{ taskDetail.membersNum }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">任务单价：</div>
          <div>￥{{ taskDetail.unitPrice }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">任务金额：</div>
          <div>￥{{ taskDetail.price }}</div>
        </div>
        <div class="title">违约详情</div>
        <div class="infoItem">
          <div class="infoTitle">违约编号：</div>
          <div>{{ detail.violateLogNo }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">违约人：</div>
          <div>{{ detail.memberName }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">违约事项：</div>
          <div>{{ detail.matterMemo }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">违约时间：</div>
          <div>{{ detail.violateAt }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">触发规则编号：</div>
          <div>{{ detail.violateRuleId }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">违约金额：</div>
          <div>￥{{ detail.violateAmount }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">第三方支付流水号：</div>
          <div>{{ detail.paymentOrder }}</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">支付方式：</div>
          <div v-if="detail.channelType == 0">钱包</div>
          <div v-if="detail.channelType == 1">对公转账</div>
          <div v-if="detail.channelType == 2">银行卡</div>
          <div v-if="detail.channelType == 3">支付宝</div>
          <div v-if="detail.channelType == 4">微信</div>
        </div>
        <div class="infoItem">
          <div class="infoTitle">支付状态：</div>
          <div>{{ detail.status == 0 ? "待支付" : "已支付" }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      editId: "",
      detail: {},
      taskDetail: {},
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.$axios
        .post(`/admapi/violate/get/${this.editId}`)
        .then(({ data }) => {
          this.detail = data;
          this.getTask(data.jobId);
        })
        .catch()
        .finally();
    },
    getTask(id) {
      console.log(id);
      this.$axios
        .post(`/admapi/job/get/${id}`)
        .then(({ data }) => {
          this.taskDetail = data;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
}
.infoItem {
  display: flex;
  align-items: center;
  color: #4f4b4b;
  margin-bottom: 15px;
}
.infoTitle {
  color: #000;
  flex: none;
}
</style>
